import { useQuery, UseQueryResult } from "react-query"

import { QueryKey } from "@/configs/queryKeys"
import {IBuscarItensVendaResultado } from "@/interfaces/pedidos"
import { getBuscarItensVenda } from "@/services/pedidos"

export function useGetBuscarItensVenda({
    params
  }: {
    params: {
      inicio?: number
      comprimento?: number
      procurar?: string
      idPedidoVenda: string
      idOperadora?: string
      campo?: string
      direcao?: string
      idUnidade?: string
      tipoVenda?: string
      agrupar?: boolean
      situacoesItem?: string[]
      somenteErros?: boolean
    }
  }): UseQueryResult<IBuscarItensVendaResultado> {
    return useQuery([QueryKey.buscarItensVenda, { params }], getBuscarItensVenda, {
      enabled: !!params.idPedidoVenda,
      retry: true,
      keepPreviousData: false,
      cacheTime: 0
    })
  }
